module.exports = __webpack_public_path__ + "static/media/master.7b7b7cbe.png";